<template>
  <div id="EditTeacher" class="well" style="padding: 0 1em">
    <div >
      <div class="course_title">修改教師資料</div>

      <div class="form-group">
        <table class="table" style="width: auto; align: left">
          <tbody>
            <tr>
              <td colspan="4" align="left">
                <span style="color: #f00"
                  ><span style="color: #f00">＊</span>為必填項目。</span
                >
              </td>
            </tr>
              <tr align="left">
              <td><span class="red_star">＊</span>教師編號</td>
              <td>
                {{inputData.tid}}

              </td>
              <td></td>
              <td></td>
            </tr>
            <tr align="left">
              <td><span class="red_star">＊</span>教師帳號(身分證字號)</td>
              <td>
                <input
                  type="text"
                  class="form-control"
                  v-model="inputData.idNo"
                  required
                />
              </td>
              <td></td>
              <td></td>
            </tr>
            <tr align="left">
              <td><span class="red_star">＊</span>姓名</td>
              <td>
                <input
                  type="text"
                  class="form-control"
                  v-model="inputData.name"
                  required
                />
              </td>
              <td class="td_left"></td>
              <td></td>
            </tr>
            <tr align="left">
              <td><span class="red_star">＊</span>職稱</td>
              <td>
                <input
                  type="text"
                  class="form-control"
                  v-model="inputData.jobTitle"
                  required
                />
              </td>
              <td class="td_left"></td>
              <td></td>
            </tr>
            <tr align="left">
              <td><span class="red_star">＊</span>服務單位</td>
              <td>
                <input
                  type="text"
                  class="form-control"
                  v-model="inputData.serviceUnit"
                  required
                />
              </td>
              <td class="td_left"></td>
              <td></td>
            </tr>
            <tr align="left">
              <td><span class="red_star">＊</span>連絡電話</td>
              <td>
                <input
                  type="text"
                  class="form-control"
                  v-model="inputData.cellPhone"
                  required
                />
              </td>
              <td class="td_left"></td>
              <td></td>
            </tr>
            <tr align="left">
              <td><span class="red_star">＊</span>Email</td>
              <td>
                <input
                  type="text"
                  class="form-control"
                  v-model="inputData.email"
                  required
                />
              </td>
              <td class="td_left"></td>
              <td></td>
            </tr>

            <tr style="text-align: center">
              <td colspan="4" align="center">
                <button
                  class="btn active bg-info text-white rounded"
                  @click="EditociaRepTeacher()"
                >
                  送出修改
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

  </div>
</template>

<script>
import * as tools from '../tool'

export default {
  name: 'EditTeacher',
  props: ['TID'],
  data () {
    return {
      show: true,
      mode: 0,
      file: [{ name: '', RowId: '' }],
      RefundMode: 0,
      RefundFile: [{ name: '', RowId: '' }],
      newPsWord: '',
      newPsWord2: '',
      Y1: '',
      M1: '',
      D1: '',
      Sex_Array: ['', '男', '女'],
      registerSuccessShow: 0,
      idCheckShow1: 0,
      idCheckShow: true,
      total: 0,
      isIE: false,
      inputData: {
        tid: '',
        idNo: '',
        name: '',
        jobTitle: '',
        serviceUnit: '',
        cellPhone: '',
        email: ''
      },
      selectedRowIndex: 0,
      currentPage: 1,
      pageSize: 10,
      captchaInfoArray: {
        text1: '',
        text2: '',
        text3: ''
      },
      captchaInfo: '',
      checkIdNo: '',
      attributesClassID: '', // 1:現職人才培育課程/2:專業證照課程/3:創客基地課程
      queryInfo: {
        StdID: 0,
        sysId: 0,
        Name: '',
        Sex: '',
        Birth: '',
        IdNo: '',
        EMail: '',
        ComName: '',
        ComEmail: '',
        ComTel: '',
        PsWord: '',
        PhoneNo1: '',
        PhoneNo2: '',
        MailAddress: '',
        VerifyCode: '',
        Agree: '',
        ServiceUnit: '',
        Transportation: '',
        TransportationArray: [],
        PlateNumber: '',
        EatingHabits: '',
        EPaper: '',
        Offer: '',
        Info: [],
        Info2: [],
        RowId: '',
        RefundRowId: '',
        Receipt: 0,
        Refund: 0,
        RefundBankName: '',
        RefundBranchBank: '',
        RefundBankAccount: '',
        RefundBankAccountName: ''
      }
    }
  },
  computed: {},
  methods: {

    close () {
      this.$emit('hideModal')
    },
    isEmpty (data) {
      return !(data != null && data != undefined && data.length > 0)
    },
    checkSaveData () {
      var msg = ''

      if (this.isEmpty(this.inputData.idNo)) {
        msg = '請輸入教師帳號(身分證字號)'
      } else if (this.isEmpty(this.inputData.name)) {
        msg = '請輸入姓名'
      } else if (this.isEmpty(this.inputData.jobTitle)) {
        msg = '請輸入職稱'
      } else if (this.isEmpty(this.inputData.serviceUnit)) {
        msg = '請輸入服務單位'
      } else if (this.isEmpty(this.inputData.cellPhone)) {
        msg = '請輸入連絡電話'
      } else if (this.isEmpty(this.inputData.email)) {
        msg = '請輸入Email'
      }

      return msg
    },

    EditociaRepTeacher: function () {
      var msg = this.checkSaveData()
      if (msg.length != 0) {
        alert(msg)
        return null
      }

      const vm = this

      this.$http
        .put('./WebApi/ociaRep/EditociaRepTeacher/', this.inputData)
        .then((response) => {
          if (response.data > 0) {
            tools.showAlert(vm, 'success', '恭喜您,存檔成功')
            this.close()
          } else {
            alert('修改失敗!!')
          }
        })
        .catch(function (error) {
          tools.showAlert(vm, 'danger', '對不起,網路連線失敗' + error)
        })
    },
    getTeacher () {
      const vm = this

      var url = './WebApi/ociaRep/GetociaRepCheckByTID/'.concat(
        this.$props.TID
      )

      this.$http
        .get(url)
        .then((response) => {
          if (response.data != null) {
            vm.inputData = response.data
          }
        })
        .catch(function (error) {
          alert('對不起,網路連線失敗,請重新輸入' + error)
          // tools.showAlert(vm, "danger", "網路連線失敗" + error);
        })
    }
  },
  created () {
    console.log('======created View =====')
    this.getTeacher()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
